/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useEstGoldStore = defineStore("estgold", {
  actions: {
    async estGoldInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/gold/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async estGoldAddFetch(payload) {
      const body = {
        lotUid: payload.lotUid,
        estimatePrice: payload.estimatePrice,
        remark: payload.remark,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/gold/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async estGoldUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        estimatePrice: payload.estimatePrice,
        remark: payload.remark,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/breaking/lot/gold/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
